import styled from '@emotion/styled'

import { Title } from '@surglogs-app/ui'

export const ErrorScreenContentHeadline = styled(Title)`
  font-size: 80px;
  line-height: 80px;
`
